import { defineMessage } from 'services/localization';

export const messages = {
    sectionHeaderText: defineMessage('expenses'),
    receivedColumnName: defineMessage('received'),
    receivedTooltip: defineMessage('received'),
    accountColumnName: defineMessage('account'),
    amountColumnName: defineMessage('amount'),
    memoColumnName: defineMessage('memo'),
};
